<template>
    <AppPage title="Obrigado!" :check-user-permission="false">
        <div class="has-text-centered content">
            <b-icon icon="check" class="icon-success"></b-icon>
            <p>O pedido número <strong>{{ orderNumber }}</strong> foi criado com sucesso!</p>
            <p v-if="successMessage">{{ successMessage }}</p>
            <router-link :to="{name: 'user.orders'}" class="button is-primary is-rounded is-outlined">
                Ver meus pedidos
            </router-link>
        </div>
    </AppPage>
</template>

<script>
import AppPage from "@/components/AppPage";
import {get as getConf} from "@/modules/conf/conf.actions";

export default {
    name: "orderCreated",

    components: {
        AppPage
    },

    props: {
        orderNumber: {
            required: true
        }
    },

    data() {
        return {
            successMessage: null
        }
    },

    async created() {
        const loading = this.$buefy.loading.open();
        this.successMessage = await getConf('order-success');

        loading.close();

    }
}
</script>

<style lang="scss">
@import "@/styles/config";

.icon {
    &.icon-success {
        color: $primary;
        width: 6rem;
        height: 6rem;

        svg {
            width: 5rem;
            height: 5rem;
        }
    }
}
</style>